<template>
    <v-container>
        <v-row>
            <!--fast-add :serviceid="itemID" :item="{name_full:'Заплатка UMICRO', price:300}"/-->
            <v-col cols="12" sm="3">
                <ChooseOfWheels v-model="wheels" />
            </v-col>
            <v-col cols="12" sm="9">
                <v-card flat>
                    <v-overlay
                        v-if="tabs.length === 0"
                        absolute
                        color="#036358"
                    >
                        Выберете колесо
                    </v-overlay>
                    <v-tabs
                            v-model="tab"
                    >
                        <v-tab
                                v-for="item in tabs"
                                :key="item.key"
                                @click="isFirstTab = false"
                        >
                            <v-img :src="icon[item.icon]" aspect-ratio="2" contain class="tabs_icons"></v-img>
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item
                                v-for="item in tabs"
                                :key="item.key"
                        >
                            <v-card flat class="main_bg_color">
                                <v-card-text class="pt-1 pb-0">
                                    <p class="subtitle-1 mb-0">Колеса</p>
                                    <wheelRadius :side="item.key"  source="repair" />
                                    <p class="subtitle-1 mb-0">Порез</p>
                                    <wheelDamage :side="item.key" />
                                    <p class="subtitle-1 mb-0">Заплатка</p>
                                    <wheelPatch :validation="validation" :side="item.key" />
                                    <wheelPlus :side="item.key" />
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="9" class="result-text">
                <p v-for="(item,index) in getTotalWheelsInfo(showActive)" :key="index">
                    {{ "[" + item.item.side + "] " + item.text }}
                </p>
            </v-col>
            <v-col cols="12" sm="3" class="pt-0">
                <div class="price mb-3">
                                            <span class="fullprice" v-if="discount>0">
                                                {{numberWithSpaces(totalPriceFull)}} ₽
                                            </span>
                    <span class="discount" v-if="discount>0">
                                                -{{ discount }}%
                                            </span>
                    <span class="discountprice">
                                                {{numberWithSpaces(totalPrice)}} ₽
                                            </span>
                    <!--span v-if="timeToSet>0" class="timeToSet">
                                                {{ timeToSet }}
                                            </span-->
                </div>
                <v-btn data-test-id="addDiskDamage" large color="#C8FA92" block @click="addServiceToCart">
                    Добавить
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: ['itemID'],
        components: {
            // fastAdd: () => import('./fast-add'),
            ChooseOfWheels: () => import('./ChooseOfWheels'),
            wheelRadius: () => import('./wheelRadius'),
            wheelDamage: () => import('./tireRepair/wheelDamage'),
            wheelPatch: () => import('./tireRepair/wheelPatch'),
            wheelPlus: () => import('./tireRepair/wheelPlus'),
        },
        computed: {
            ...mapGetters([
                "calcSubTypes",
            ]),
            MushroomRepair() {
                return this.calcSubTypes.find(x => x.calc_subtype == 'MushroomRepair' )
            },
            HotVulkan() {
                return this.calcSubTypes.find(x => x.calc_subtype == 'HotVulkan' )
            },
            ColdVulkan() {
                return this.calcSubTypes.find(x => x.calc_subtype === 'ColdVulkan' )
            },
            TyreRepairCalc() {
                return this.calcSubTypes.find(x => x.calc_subtype == 'TyreRepairCalc' )
            },
            icon () {
                return this.$store.state.imgs.icon
            },
            carType () {
                return this.$store.state.clientCard.carType
            },
            discount () {
                return (this.$store.state.clientIdentify.client.discount.value + this.$store.state.clientIdentify.client.additional_discount.value) * 100
            },
            showActive () {
                let active = []
                const wheelsName = [ 'forwardLeft', 'forwardRight', 'backLeft', 'backRight', 'spareLeft', 'spareRight' ]
                const wheelsNameRus = [ 'Переднее левое', 'Переднее правое', 'Заднее левое', 'Заднее правое', 'Запасное левое', 'Запасное правое' ]
                wheelsName.forEach((key,index) => {
                    if (this.$store.state.repair.wheels[key] && this.$store.state.repair.wheels[key].isActive) {
                        active.push({name: wheelsNameRus[index], wheelsName: key, data: this.$store.state.repair.wheels[key]})
                    }
                })
                return active
            },
            tabs() {
                let res = [];
                const icons = ['fl', 'fr', 'bl', 'br', 'sl', 'sr'];
                let i = 0;
                for (const key in this.wheels) {
                    if (this.wheels[key]) {
                        res.push({key: key, icon: icons[i], slot: icons[i]})
                    }
                    i++;
                }
                return res
            },
            QRcodeUrl() {
                return this.$store.state.repair.QRcodeUrl
            },
            wheels: {
                get() {
                    return {
                        forwardLeft: this.$store.state.repair.wheels.forwardLeft.isActive,
                        forwardRight: this.$store.state.repair.wheels.forwardRight.isActive,
                        backLeft: this.$store.state.repair.wheels.backLeft.isActive,
                        backRight: this.$store.state.repair.wheels.backRight.isActive,
                        spareLeft: this.$store.state.repair.wheels.spareLeft.isActive,
                        spareRight: this.$store.state.repair.wheels.spareRight.isActive
                    }
                },
                set(value) {
                    this.$store.dispatch('repair/changeActiveWheels', value)
                }
            },
            isFirstTab: {
                get() {
                    return this.$store.state[this.source].isFirstTab
                },
                set(value) {
                    this.$store.commit(this.source + '/setIsFirstTab', value )
                }
            },

        },
        data() {
            return {
                validation: false,
                source: 'repair',
                quantity: 1,
                allValues: [],
                timeToSet: 0,
                showInfo:false,
                totalPrice: null,
                totalPriceFull: null,
                resultText: 'Ремонт бокового пореза шины размером 3х5 мм, заплатка «Стандарт» с применением горячей вулканизации с восстановлением защитной кромки',
                tab: null,
                panel: null, // null - скрыть / 0 - раскрыть
                title: 'Ремонт пореза или прокола',
                myInputModel: '',
                dropped: true,
            }
        },
        methods: {
            validData () {
                let allGood = true
                this.allValues.forEach((x)=>{
                    console.log('--0-0-000---', x)
                    if(!(x.price>0 && x.item.PatchSelected.id && x.item.PatchSelected.name_full && x.item.PatchType)) {
                        this.validation = true
                        this.tab = this.tabs.findIndex(item => item.key === x.wheelsName)
                        allGood = false
                    }
                })
                return allGood
            },
            async addServiceToCart() {
                if (this.validData()) {
                    let service = this.$store.getters.services[this.itemID]
                    for (let i=0; i < this.allValues.length; i++) {
                        const x = this.allValues[i]
                        console.log('-----', x)
                        let description = x.item.PatchSelected.name_full
                        description = x.item.edgeRestoration ? description + ' вост. кромки' : description
                        description = x.item.hotVulcan ? description + ' гор. вулк' : description
                        await this.$store.dispatch('addServiceToCart', {
                            'service': service,
                            'id': x.item.serviceID,
                            'client': this.$store.getters.client ,
                            'quantity': x.item.quantity,
                            'description': '[' + x.item.side + '] ' + x.text,
                            'price': x.price,
                            'params': {
                                description: description,
                                text: '[' + x.item.side + '] ' + x.text,
                                content: x,
                                diskType: x.item.solidDisk?'Литой диск':'Штампованый диск',
                                diskR: 'R' + x.item.radius,
                                carType: this.carType,
                                wheelSide: x.item.name,
                                isRunflat: x.item.isRunflat,
                                hotVulcan: x.item.hotVulcan, // Горячая вулканизация
                                edgeRestoration: x.item.edgeRestoration, // Восстановление защитной кромки
                                patch:  // Инфо о заплатке
                                    {
                                        id: x.item.PatchSelected.id,
                                        name: x.item.PatchSelected.name_full,
                                        type: x.item.PatchType,
                                    },
                            },
                        })
                    }
                }
            },
            numberWithSpaces(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            },
            infoClick(){
                this.showInfo = !this.showInfo
                console.log('infotext')
            },
            getTotalWheelsInfo: function (value) {
                let allValues = []
                let totalPrice = 0
                let timeToSet = 0
                value.forEach((x) => {
                    let name = x.name
                    const wheelsName = x.wheelsName
                    x=x.data.data
                    x.side = this.shortSidename(name)
                    x.name = name
                    let radtext = x.radius?'R' + x.radius+' ':''
                    let text = radtext
                    let price = 0
                    let basecost = x?x.PatchPrice:0
                    let PatchType = x?x.PatchType:0
                    if (x.time_hot || x.time_cold) {
                        timeToSet = timeToSet + x.hotVulcan ? x.time_hot : x.time_cold
                    }
                    if (basecost>0){
                        price = price + basecost
                    }
                    if (x.radiusRate > 0 && x.PatchSelected.extra_radius>0) {
                        price = price + Math.round(basecost / 100 * x.radiusRate)
                    }
                    if (x.cutWidth > 0 || x.cutHeight > 0) {
                        text = text + 'Ремонт '
                            + this.$store.state.repair.cutTypeList[x.cutType].toLowerCase().replace('й','го')
                            + ' пореза шины размером '
                            + x.cutWidth + 'x'
                            + x.cutHeight + ' мм'
                    }
                    /*
                    if (x.cameraRepair && x.cameraRepairVol > 0) {
                        price = price + x.cameraRepairVol * this.$store.state.repair.cameraRepairPrice
                        text = text + ' ремонт камеры(' +x.cameraRepairVol+'шт.)'
                    }
                    if (x.hareness && x.harenessVol > 0) {
                        price = price + x.harenessVol * this.$store.state.repair.harenessPrice
                        text = text + ' установка жгута (' + x.harenessVol + 'шт.)'
                    }
                    */
                    if (Object.keys(x.PatchSelected).length !== 0){
                        x.serviceID = this.ColdVulkan.id
                        if (x.hotVulcan) {
                            text = text + ', с применением горячей вулканизации'
                            price = price + x.PatchSelected.extra_hot
                            x.serviceID = this.HotVulkan.id
                        }
                        if (x.edgeRestoration) {
                            text = text + ', с восстановлением защитной кромки'
                            price = price + Math.round(basecost / 100 * x.PatchSelected.extra_repair)
                        }
                        if (x.isRunflat && PatchType !== 'Грибок') {
                            price = price + Math.round(basecost / 100 * x.PatchSelected.extra_runflat)
                        }
                        if (PatchType == 'Грибок') {
                            x.serviceID = this.MushroomRepair.id
                        }
                    }
                    totalPrice = totalPrice + price
                    if (allValues.length > 0) {
                        const i = allValues.findIndex(val => val.text == text && val.price == price);
                        if (i >= 0) {
                            x.side = allValues[i].item.side + "," + x.side;
                            x.quantity = allValues[i].item.quantity + 1;
                            allValues.splice(i, 1, {
                                text,
                                item: x,
                                price: allValues[i].price
                            });
                        } else {
                            x.quantity = 1;
                            allValues.push({ text, item: x, wheelsName: wheelsName, price: price });
                        }
                    } else {
                        x.quantity = 1;
                        allValues.push({ text, item: x, wheelsName: wheelsName, price: price });
                    }
                    // if ( text != '') {
                    //     const valueToAdd = { text, price, item: x }
                    //     allValues.push(valueToAdd)
                    // }
                })
                this.timeToSet = timeToSet
                this.totalPrice = Math.round((totalPrice - totalPrice / 100 * this.discount))
                this.totalPriceFull = Math.round(totalPrice)
                this.$store.commit('updateServicesPrice', [this.itemID ,this.totalPriceFull])
                this.allValues = allValues
                return allValues
            },
            shortSidename(sideName) {
                const wheelsName = ["ПЛ", "ПП", "ЗЛ", "ЗП", "ЗАП1", "ЗАП2"];
                const wheelsNameRus = [
                    "Переднее левое",
                    "Переднее правое",
                    "Заднее левое",
                    "Заднее правое",
                    "Запасное левое",
                    "Запасное правое"
                ];
                let index = wheelsNameRus.findIndex(x => x == sideName);
                return wheelsName[index];
            },
            onTabChange () {
                if(this.isFirstTab) {
                    this.$store.dispatch('copySide', this.tabs[0].slot)
                }
            }
        },
        created() {
            this.$store.dispatch('repair/init')
            this.$store.dispatch('repair/cutRepairPrice').then((resp) => {
                console.log('cutRepairPrice:', resp)
                this.$store.dispatch('repair/addExtraPrice')
            }).catch((e) =>{
                console.log('error:',e)
            })
        },
    }
</script>
